import { Component, OnDestroy, OnInit } from '@angular/core';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { ManagedUploadItem, UploadManagerService } from 'app/services/upload-manager.service';

@Component({
    selector: 'app-global-upload',
    templateUrl: './global-upload.component.html',
    styleUrls: ['./global-upload.component.scss'],
    standalone: false
})
export class GlobalUploadComponent implements OnInit, OnDestroy {

    public uploadMinimized: boolean = false;
    public uploadHidden: boolean = false;

    private _uploadWasActive: boolean = false;

    private _unsubscribeAll: Subject<any> =
        new Subject<any>();


    constructor(
        public uploadManagerService: UploadManagerService
    ) {}


    ngOnInit(): void {

        this.uploadManagerService.status$
            .pipe(
                takeUntil(this._unsubscribeAll)
            )
            .subscribe(upload => {

                /*
                 * Si comienza una nueva subida,
                 * mostramos nuevamente la tarjeta.
                 */
                if (
                    upload.active &&
                    !this._uploadWasActive
                ) {
                    this.uploadHidden = false;
                    this.uploadMinimized = false;
                }


                /*
                 * Si aparece un duplicado,
                 * necesitamos mostrarlo para que
                 * el usuario pueda decidir.
                 */
                if (
                    upload.active &&
                    upload.duplicates.length > 0
                ) {
                    this.uploadHidden = false;
                    this.uploadMinimized = false;
                }


                /*
                 * Al finalizar dejamos limpio
                 * el estado visual.
                 */
                if (!upload.active) {
                    this.uploadHidden = false;
                    this.uploadMinimized = false;
                }


                this._uploadWasActive =
                    upload.active;
            });
    }


    ngOnDestroy(): void {

        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }


    toggleUploadMinimized(): void {

        this.uploadMinimized =
            !this.uploadMinimized;
    }


    hideUploadCard(): void {

        this.uploadHidden = true;
    }

    getPdfOptions(items: ManagedUploadItem[]): ManagedUploadItem[] {
        return items.filter(item => item.state === 'options');
    }

    isPdf(item: ManagedUploadItem): boolean {
        return item.fileInfo?.contentType === 'PDF';
    }

}